<div class="aems-bread-crumb m-b-16">
  <a class="m-r-4" routerLink="/master-data">Master Data</a>
  <span class="m-r-4">/ </span>
  <a class="m-r-4" routerLink="/master-data/shop-management">Shop Management</a>
  <span>/ {{ isEditMode() ? 'Edit Shop' : 'Add New' }}</span>
</div>

<div class="m-b-12" style="display: flex; align-items: center; gap: 12px">
  <h3>{{ isEditMode() ? 'Edit Shop' : 'Add New' }}</h3>
  @if (isEditMode() && authPolicy.canViewShopManagement) {
    <div style="display: flex; flex-grow: 1; justify-content: end; gap: 8px">
      <mc-button
        fit="small"
        variant="outlined"
        icon="arrow-anti-clockwise-clock"
        (click)="onAuditLogClicked()"
        (keydown)="onAuditLogClicked()">
        Audit log
      </mc-button>
    </div>
  }
</div>

@if (isEditMode() && shopData()) {
  <div class="mds-text--body-normal mds-neutral--weak__text-color m-b-12">
    Last updated on {{ shopData()?.updatedAt | date: 'medium' }} by {{ shopData()?.updatedBy || 'User' }}
  </div>
}

<form [formGroup]="createShopForm">
  @if (formSubmitErrors().length > 0) {
    <div class="error m-b-8">
      <mc-icon class="error-icon" icon="exclamation-octagon" size="20"></mc-icon>
      <div class="title">Errors</div>
      <ul>
        @for (error of formSubmitErrors(); track $index) {
          <li>{{ error }}</li>
        }
      </ul>
    </div>
  }
  <div class="flex-column">
    @if (formSubmitErrors().length === 0) {
      <app-error [formContainer]="createShopForm"></app-error>
    }
  </div>

  <div class="pure-g">
    <!-- Shop Information Section -->
    <div class="pure-u-1 pure-u-md-2-3 pure-u-lg-2-3 p-r-8">
      <div class="aems-card m-b-16">
        <p class="mds-content"><strong>Shop Information</strong></p>
        <hr class="m-b-12" />
        @if (isEditMode()) {
          <app-edit-shops-shop-information [formGroup]="createShopForm"> </app-edit-shops-shop-information>
        } @else {
          <app-create-shops-shop-information [formGroup]="createShopForm"> </app-create-shops-shop-information>
        }
      </div>
    </div>

    <!-- Financial Configuration Section -->
    <div class="pure-u-1 pure-u-md-1-3 pure-u-lg-1-3">
      <div class="aems-card m-b-16">
        <p class="mds-content"><strong>Financial Configuration</strong></p>
        <hr class="m-b-12" />
        <app-create-shops-financial-configuration [formGroup]="createShopForm"> </app-create-shops-financial-configuration>
      </div>
    </div>

    <!-- Operational Settings Section -->
    <div class="pure-u-1">
      <div class="aems-card m-b-16">
        <p class="mds-content"><strong>Operational Settings</strong></p>
        <hr class="m-b-12" />
        <app-create-shops-operational-settings [formGroup]="createShopForm"> </app-create-shops-operational-settings>
      </div>
    </div>
  </div>

  <!-- Action Buttons -->
  <div class="pure-g m-t-16">
    <div class="pure-u-1 right">
      @if (isEditMode()) {
        <mc-button
          type="button"
          variant="outlined"
          appearance="neutral"
          fit="small"
          class="m-r-8"
          (click)="onCancel()"
          (keydown)="onCancel()">
          Cancel
        </mc-button>
      }
      <mc-button
        type="button"
        variant="filled"
        appearance="primary"
        fit="small"
        [disabled]="createShopForm.invalid || submitLoader()"
        [loading]="submitLoader()"
        (click)="onSubmit()"
        (keydown)="onSubmit()">
        {{ isEditMode() ? 'Save changes' : 'Submit' }}
      </mc-button>
    </div>
  </div>
</form>

<!-- Cancel Confirmation Modal -->
@if (showCancelDialog()) {
  <mc-modal heading="Unsaved Changes" fit="small" dimension="small" [open]="showCancelDialog()" (closed)="keepEditing()">
    <p>Are you sure you want to cancel shop editing? All unsaved changes will be lost permanently.</p>
    <mc-button
      slot="secondaryAction"
      dialogaction="cancel"
      appearance="neutral"
      variant="filled"
      (click)="keepEditing()"
      (keydown)="keepEditing()">
      Keep Changes
    </mc-button>
    <mc-button slot="primaryAction" appearance="primary" variant="filled" (click)="confirmCancel()" (keydown)="confirmCancel()">
      Discard changes
    </mc-button>
  </mc-modal>
}

<mc-modal backdropcloseactiondisabled heading="Audit Log" fit="small" dimension="large" [open]="openAuditLog" (closed)="onAuditLogClosed()">
  @if (openAuditLog) {
    <app-master-data-audit-log [transactionCode]="shopCode" [label]="'Shop Code'" [auditLogFetcher]="auditLogFetcher">
    </app-master-data-audit-log>
  }
</mc-modal>
